import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import Drip from '@/drip';
import { isProd, domain } from '@/config';
var beforeHash = /(?=#)/;
var hasFromTagReg = /(fromTag=)[^&#]+/;
var hasUTMSOURCEReg = /(utm_source=)[^&#]+/;
var hasKingTokenTag = /(kingToken=)[^&]+/;
var _window$location = window.location,
  href = _window$location.href,
  search = _window$location.search,
  protocol = _window$location.protocol;
var separate = search ? '&' : '?';
export var shareQQHost = "".concat(protocol, "//show").concat(isProd ? '' : '.test', ".maoyan.com");
export var ipShareHost = "".concat(protocol, "//").concat(domain, "/app/myshow/#/");
var _Drip$constant = Drip.constant,
  _Drip$constant$uaInfo = _Drip$constant.uaInfo,
  IS_MEITUAN = _Drip$constant$uaInfo.IS_MEITUAN,
  IS_MAOYAN = _Drip$constant$uaInfo.IS_MAOYAN,
  IS_GEWARA = _Drip$constant$uaInfo.IS_GEWARA,
  IS_DIANPING = _Drip$constant$uaInfo.IS_DIANPING,
  _shareTag = _Drip$constant.shareTag;
export var getShareAppUrl = function getShareAppUrl() {
  return ipShareHost;
  // if(IS_DIANPING) {
  //   return ipShareHost
  // }

  // return  `${shareQQHost}/qqw/#/`
};

export function getDetailShareLink(performanceId, options) {
  var shareTag = options ? options.shareTag : _shareTag;
  if (IS_MEITUAN || IS_MAOYAN || IS_GEWARA) {
    var shareUrl = "".concat(shareQQHost, "/qqw#/detail/").concat(performanceId, "?fromTag=").concat(shareTag, "&utm_source=").concat(shareTag);
    return shareUrl;
  } else {
    var url = href;
    if (href.includes('fromTag=') || href.includes('utm_source=')) {
      url = url.replace(hasFromTagReg, "$1".concat(shareTag));
      url = url.replace(hasUTMSOURCEReg, "$1".concat(shareTag));
      return url;
    } else {
      url = url.replace(beforeHash, "".concat(separate, "fromTag=").concat(shareTag, "&utm_source=").concat(shareTag));
      return url;
    }
  }
}
export function getTopShareUrl() {
  return "".concat(shareQQHost, "/qqw").concat(window.location.hash);
}
export function getBrandShareUrl() {
  return "".concat(shareQQHost, "/qqw").concat(window.location.hash);
}
export function getArtistShareUrl() {
  return "".concat(shareQQHost, "/qqw").concat(window.location.hash);
}